import { Box, Stack, Typography } from '@mui/material';
import React from 'react';
import { Cell, Label, Pie, PieChart } from 'recharts';

const CreditChart = ({
  direction = 'row',
  usedCredit = 8,
  totalCredit = 9,
  scale = 1,
}) => {
  const data = [
    {
      text: 'Used',
      value: usedCredit,
      valueText: `${usedCredit}`,
      color: 'rgba(236, 178, 46, 1)',
    },
    {
      text: 'Remaining Credit',
      value: totalCredit - usedCredit,
      color: 'rgba(220, 220, 220, 1)',
      valueText: `${totalCredit - usedCredit}`,
    },
  ];

  const percent = ((usedCredit / totalCredit) * 100)
    .toFixed(2)
    .replace('.00', '');

  return (
    <Box
      display={'flex'}
      flexDirection={direction}
      alignItems={'center'}
      gap={1.5}
    >
      <PieChart width={102 * scale} height={102 * scale}>
        <Pie
          data={data}
          dataKey={'value'}
          innerRadius={35 * scale}
          outerRadius={50 * scale}
          startAngle={90}
          endAngle={-270}
        >
          {data.map((entry, index) => (
            <Cell
              style={{ outline: 'none' }}
              key={`cell-${index}`}
              fill={entry.color}
              fillOpacity={1}
            />
          ))}
          <Label
            position={'center'}
            fontWeight={600}
            style={{
              fill: 'black',
            }}
          >{`${percent}%`}</Label>
        </Pie>
      </PieChart>
      <Box width={'100%'}>
        {data.map((i) => {
          return (
            <Stack key={i.text} direction={'row'} gap={'10px'} mb={'5px'}>
              <Box
                width={16}
                height={16}
                bgcolor={i.color}
                borderRadius={'4px'}
              />
              <Typography fontWeight={500} fontSize={12}>
                {i.text} {i.valueText}
              </Typography>
            </Stack>
          );
        })}
      </Box>
    </Box>
  );
};

export default CreditChart;
